/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Result details of the invitation attempt
 * @export
 * @interface InviteUserFromUser200ResponseResult
 */
export interface InviteUserFromUser200ResponseResult {
    /**
     * Result status of the invitation
     * @type {string}
     * @memberof InviteUserFromUser200ResponseResult
     */
    'result': InviteUserFromUser200ResponseResultResultEnum;
    /**
     * Reason for failure if result is FAILURE
     * @type {string}
     * @memberof InviteUserFromUser200ResponseResult
     */
    'reason'?: string | null;
}

export const InviteUserFromUser200ResponseResultResultEnum = {
    success: 'SUCCESS',
    failure: 'FAILURE'
} as const;

export type InviteUserFromUser200ResponseResultResultEnum = typeof InviteUserFromUser200ResponseResultResultEnum[keyof typeof InviteUserFromUser200ResponseResultResultEnum];


